import './Links.scss';

import cn from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import LinkLikeButton from '@/common/components/blocks/LinkLikeButton/LinkLikeButton';
import { ROUTE_SCANBAT } from '@/common/constants';
import { ReactComponent as AubadeIcon } from '@/ebat/assets/icons/aubade.svg';
import { ReactComponent as DownloadIcon } from '@/ebat/assets/icons/download.svg';
import { ReactComponent as VideoIcon } from '@/ebat/assets/icons/player.svg';
import { ReactComponent as PrintIcon } from '@/ebat/assets/icons/print.svg';

import { LinksDefaultProps, LinksPropTypes } from './Links.proptypes';
import useLinks from './useLinks';

const Links = ({
  className,
  handleClickItem,
  hasPrint,
  links,
  slider,
  video,
  path,
  slug,
}) => {
  const { t } = useTranslation();
  const isScanbat = window.location.pathname.includes(ROUTE_SCANBAT);

  const { handleOpenModal, hasLinks } = useLinks({
    hasPrint,
    links,
    video,
    path,
    slug,
  });

  const handleOpenVideo = () => {
    const index = slider.indexOf(
      slider.find((item) => item.code === video.code),
    );

    if (index !== -1) {
      handleClickItem(index);
    }
  };

  if (hasLinks) {
    return (
      <div className={cn('links', className)} data-qa-id="links">
        <ul className="list list--buttons" data-qa-id="link-list">
          {Object.keys(links).length > 0 &&
            Object.keys(links).map((link, index) => (
              <li
                className="list__item"
                key={`list-item-${index}`}
                data-qa-id="link-item"
              >
                <LinkLikeButton
                  context="product-link"
                  external
                  url={Object.values(links)[index]}
                  variant="secondary-light"
                  withIcon
                >
                  {link === 'link_aubade' ? (
                    <AubadeIcon className="button__icon" />
                  ) : (
                    <DownloadIcon className="button__icon" />
                  )}
                  <span className="button__label">
                    {t(`ebat:entities:product.downloads.${link}`)}
                  </span>
                </LinkLikeButton>
              </li>
            ))}
          {video && (
            <li className="list__item">
              <Button
                context="product-video"
                onClick={handleOpenVideo}
                variant="secondary-light"
                withIcon
              >
                <VideoIcon className="button__icon" />
                <span className="button__label">
                  {t('ebat:entities:product.downloads.video')}
                </span>
              </Button>
            </li>
          )}
          {hasPrint && !isScanbat && (
            <li className="list__item">
              <Button
                context="product-print"
                onClick={() => handleOpenModal('PrintPage')}
                variant="secondary-light"
                withIcon
              >
                <PrintIcon className="button__icon" />
                <span className="button__label">
                  {t('common:messages:actions.print')}
                </span>
              </Button>
            </li>
          )}
        </ul>
      </div>
    );
  }

  return null;
};

Links.defaultProps = {
  ...LinksDefaultProps,
};

Links.propTypes = {
  ...LinksPropTypes,
};

export default Links;
